import { Box, Typography } from '@mui/material'
import React from 'react'

const PProgressBar = ({
  progress,
  sx,
  progressColor = 'alternate.main',
  width,
  completedSub,
  totalSub,
}) => {
  return (
    <Box display="flex" alignItems="center" gap={2} width={width}>
      <Box
        width="70%"
        height="8px"
        borderRadius="4px"
        backgroundColor="#EDEFF0"
        overflow="hidden"
        sx={{ ...sx }}
      >
        <Box
          sx={{ width: `${progress ? progress : 0}%`, transition: 'width 0.3s linear' }}
          height="100%"
          borderRadius="5px"
          backgroundColor={progressColor}
        />
      </Box>
      <Typography
        width="30%"
        color="alternate.main"
        textAlign="center"
        noWrap
        variant="body1"
        fontWeight="bold"
      >
        {totalSub ? completedSub + '/' + totalSub : '...'} completed
      </Typography>
    </Box>
  )
}

export default PProgressBar
